<template>
  <interview-layout :touch-and-validate="touchAndValidate" :show-help-button="true">
    <div>
      <!-- titles -->
      <h1 class="px-4 fade-in-up-enter-active animation-slowest max-100 text-primary">Isolatieplan</h1>

      <!-- cards wrapper -->
      <div class="d-flex flex-column flex-lg-row justify-content-center">
        <!-- form card -->
        <base-card inner-class="container-narrow w-100" color="alternate" :outer-padding="true">
          <base-form @submit="onSubmit">
            <!-- Summary -->
             <div v-if="!lead.Isolatieplan_required">
            <base-card class="mb-4" inner-class="small" color="secondary">
              <h6 class="mb-2">Heb ik een isolatieplan nodig?</h6>
              <checkmark-item class="mb-2" icon="info-circle-fill" style="position:relative;">
                Als het <span v-if="lead.twk.IntakeMeasuresExecuted">totaal</span>bedrag van uw isolatiemaatregelen onder de
                <info-average-price-amount :amount="10000"/>
                blijft, dan heeft u <strong class="fw-600">geen</strong> isolatieplan nodig. U kunt direct aan de slag
                <span v-if="lead.twk.IntakeMeasuresExecuted"> met uw nieuwe maatregel</span>.
              </checkmark-item>
              <checkmark-item class="mb-2" icon="info-circle-fill" v-if="!lead.twk.IntakeMeasuresExecuted">
                De meeste enkelvoudige isolatiemaatregelen zijn onder de <info-average-price-amount :amount="10000" />.
              </checkmark-item>
              <!-- <checkmark-item class="mb-2" icon="info-circle-fill" v-if="!lead.twk.IntakeMeasuresExecuted">
                Na het ontvangen van een isolatieplan kunt u pas subsidie aanvragen. Zonder isolatieplan kunt u direct subsidie aanvragen.
              </checkmark-item> -->

              <checkmark-item class="mb-2" icon="info-circle-fill" v-if="lead.twk.IntakeMeasuresExecuted">
                Als het totaalbedrag boven de <info-average-price-amount :amount="10000"/> uitkomt, is een <strong class="fw-600">isolatieplan verplicht</strong> voordat u kunt beginnen met de werkzaamheden.
              </checkmark-item>
              <checkmark-item class="mb-2" icon="info-circle-fill" v-if="lead.twk.IntakeMeasuresExecuted">
                Dit bedrag omvat zowel de kosten van uw nieuwe maatregel als de subsidie die u al heeft ontvangen of nog van plan bent aan te vragen.
              </checkmark-item>
              <checkmark-item class="mb-2" icon="info-circle-fill">
                U kunt op een later moment altijd nog een isolatieplan aanvragen. Dit kan tot en met 2034.
              </checkmark-item>
              <checkmark-item class="mb-2" icon="info-circle-fill">
                De wachttijd op een isolatieplan is op dit moment enkele maanden.
              </checkmark-item>
            </base-card>

            <!-- Q1 -->
            <!-- <base-input
              type="radiobuttons"
              :options="yesNoOptions"
              name="HasMeasuresForRetroactive"
              v-model:value="lead.isolatieplanCheck.IntakeMeasuresExecuted"
            >
              Heeft u tussen 25 april 2023 en 3 juni 2025 opdracht gegeven of zelf isolatiemaatregelen uitgevoerd waarvoor u nog geen subsidie heeft ontvangen, maar wel geld voor terug wilt krijgen?
            </base-input> -->
            
            <!-- if answer on TWK question is: Ja -->
            <div v-if="lead.twk.IntakeMeasuresExecuted">
              <base-input
                type="radiobuttons"
                :options="yesNoOptionsQ2"
                direction="column"
                name="Under10kCombined"
                v-model:value="lead.isolatieplanCheck.Under10kCombined"
              >
                Is het totaal van uw nieuwe investering in een isolatie maatregel en NijBegun - Terugwerkende kracht lager dan &euro;10.000?
              </base-input>
            </div>

            <div v-else>
              <base-input
                type="radiobuttons"
                direction="column"
                :options="yesNoOptionsQ3"
                name="ProceedWithoutPlan"
                v-model:value="lead.isolatieplanCheck.ProceedWithoutPlan"
              >
                Wilt u weten welke isolatiemaatregelen passen bij het bouwjaar van uw woning?
              </base-input>
            </div>
          </div>

            <div v-if="lead.wantsIsolatieplan === true">
              <base-input
                type="radiobuttons"
                :options="yesNoOptions"
                
                name="IsolatieplanRequested"
                v-model:value="lead.isolatieplanCheck.IsolatieplanRequested"
              >
                  Heeft u al een isolatieplan aangevraagd?
              </base-input>
              
              <base-input
                v-if="lead.address.pc_GemNaam == 'Stadskanaal'  &&
    lead.isolatieplanCheck.IsolatieplanRequested === false"
                type="radiobuttons"
                :options="yesNoOptions"
                name="InterstedInWarmtepomp"
                v-model:value="lead.isolatieplanCheck.InterstedInWarmtepomp"
              >
                Denkt u erover na om een warmtepomp aan te schaffen?
              </base-input>

                <base-card v-if="lead.address.pc_GemNaam == 'Stadskanaal' && lead.isolatieplanCheck.InterstedInWarmtepomp === true && lead.isolatieplanCheck.IsolatieplanRequested === false" class="mb-4" inner-class="small" color="secondary">
                  <checkmark-item class="mb-2" icon="info-circle-fill">
                    De gemeente Stadskanaal biedt kosteloos een isolatieplan plus plan aan.
                  </checkmark-item>
                  <checkmark-item icon="info-circle-fill">
                    Met een isolatieplan plus plan staat er precies in met welke maatregelen uw woning aardgasvrij gemaakt kan worden.
                  </checkmark-item>
                </base-card>

              <base-input
                v-if="
                  lead.address.pc_GemNaam == 'Stadskanaal' &&
                  lead.isolatieplanCheck.IsolatieplanRequested === false &&
                  lead.isolatieplanCheck.InterstedInWarmtepomp === true
                "
                type="radiobuttons"
                :options="yesNoOptions"
                name="IsolatieplanPlus"
                v-model:value="lead.isolatieplanCheck.IsolatieplanPlus"
              >
                Stadskanaal biedt kosteloos een isolatieplan plus aan. Heeft u hier interesse in?
              </base-input> 
            
              <base-input
                v-if="lead.isolatieplanCheck.IsolatieplanRequested"
                type="radiobuttons"
                :options="yesNoOptions"
                name="IsolatieplanRequested"
                v-model:value="lead.isolatieplanCheck.IsolatieplanReceived"
              >
                Heeft u uw isolatieplan al ontvangen?
              </base-input>

              <base-input
                v-if="lead.isolatieplanCheck.IsolatieplanRequested == false"
                type="radiobuttons"
                :options="advisorSelectionOptions"
                name="residentChoosesOwnAdvisor"
                v-model:value="lead.isolatieplanCheck.residentChoosesOwnAdvisor"
              >
              Wie kiest de isolatieadviseur?
              </base-input>

            </div>
          </base-form>
        </base-card>
        <!-- form card end -->
      </div>

      <!-- navigatie knoppen buiten de kaart (zoals Financing) -->
      <button-row class="mt-2 flex-row-reverse">
        <base-button class="ms-auto" icon="bi-arrow-right" @click="onSubmit" :disabled="v$.isolatieplanCheck.$invalid">Volgende</base-button>
        <base-button variant="minimal-secondary" icon="bi-arrow-left" icon-position="start" @click="onPrev">Terug</base-button>
      </button-row>
      <!-- inner wrapper end -->
    </div>
  </interview-layout>
</template>

<script>
import InterviewLayout from "@/views/layouts/InterviewLayout.vue";
import BaseCard from "@/components/BaseCard.vue";
import BaseForm from "@/components/BaseForm.vue";
import BaseInput from "@/components/BaseInput.vue";
import BaseButton from "@/components/BaseButton.vue";
import ButtonRow from "@/components/ButtonRow.vue";
import CheckmarkItem from "@/components/CheckmarkItem.vue";
import InfoAveragePriceAmount from "@/components/InfoAveragePriceAmount.vue";
import { FlowService } from "@/services/FlowService";
import { useAllStores } from "@/helpers/UseAllStores";
import { CommonComposable } from "@/helpers/CommonComposable";

export default {
  components: {
    InterviewLayout,
    BaseCard,
    BaseForm,
    BaseInput,
    BaseButton,
    ButtonRow,
    CheckmarkItem,
    InfoAveragePriceAmount
  },
  setup(props, context) {
    return { ...CommonComposable(props, context), ...useAllStores() };
  },
  data() {
    return {
      yesNoOptions: [
        { label: 'Ja', value: true },
        { label: 'Nee', value: false },
      ],
      yesNoOptionsQ2: [
        { label: 'Ja, adviseer mij of ik nu nog een maatregel kan uitvoeren zonder isolatieplan.', value: true },
        { label: 'Nee, ik wacht liever nog een aantal maanden en kies voor een isolatieplan.', value: false },
      ],
      yesNoOptionsQ3: [
        { label: 'Ja, adviseer mij of ik nu al een maatregel kan uitvoeren', value: true },
        { label: 'Nee, ik wacht liever nog een aantal maanden en kies voor een isolatieplan.', value: false },
      ],
      advisorSelectionOptions: [
        { label: 'Laat ons een isolatieadviseur voor u kiezen', value: false },
        { label: 'Ik kies zelf een isolatieadviseur via het portaal van Nij Begun', value: true },
      ]
    };
  },
  watch: {
    // Watch for changes in Under10kCombined
    'lead.isolatieplanCheck.Under10kCombined'() {
        // Reset fields that depend on Under10kCombined
      this.lead.isolatieplanCheck.ProceedWithoutPlan = null;
      this.lead.isolatieplanCheck.IsolatieplanRequested = null;
      this.lead.isolatieplanCheck.IsolatieplanPlus = null;
      this.lead.isolatieplanCheck.IsolatieplanReceived = null;
    },

    // Watch for changes in ProceedWithoutPlan
    'lead.isolatieplanCheck.ProceedWithoutPlan'() {
        // Reset fields that depend on ProceedWithoutPlan
      this.lead.isolatieplanCheck.IsolatieplanRequested = null;
      this.lead.isolatieplanCheck.IsolatieplanPlus = null;
      this.lead.isolatieplanCheck.IsolatieplanReceived = null;
    },

    // Watch for changes in IsolatieplanRequested
    'lead.isolatieplanCheck.IsolatieplanRequested'(newValue) {
      if (newValue === true) {
        this.lead.isolatieplanCheck.InterstedInWarmtepomp = null;
        this.lead.isolatieplanCheck.IsolatieplanPlus = null;
        this.lead.isolatieplanCheck.residentChoosesOwnAdvisor = null;
      }

      if (newValue === false) {
        this.lead.isolatieplanCheck.InterstedInWarmtepomp = null;
        this.lead.isolatieplanCheck.IsolatieplanPlus = null;
        this.lead.isolatieplanCheck.residentChoosesOwnAdvisor = null;
      }

      this.lead.isolatieplanCheck.IsolatieplanReceived = null;
    },
    'lead.isolatieplanCheck.IsolatieplanPlus'(newValue) {
      if (newValue === true) {
        this.lead.isolatieplanCheck.residentChoosesOwnAdvisor = false;
      }

      if (newValue === false) {
        this.lead.isolatieplanCheck.residentChoosesOwnAdvisor = null;
      }
    },
    'lead.isolatieplanCheck.InterstedInWarmtepomp'(newValue) {
      if (newValue === false) {
        this.lead.isolatieplanCheck.IsolatieplanPlus = null;
        this.lead.isolatieplanCheck.residentChoosesOwnAdvisor = null;

      }

      if (newValue === true) {
        this.lead.isolatieplanCheck.residentChoosesOwnAdvisor = null;
      }
    },
  },
  methods: {
    touchAndValidate() {
      this.v$.isolatieplanCheck.$touch();
      return !this.v$.isolatieplanCheck.$invalid;
    },
    onSubmit() {
      if (this.touchAndValidate()) {
        FlowService.pushNext(this);
      }
    },
    onPrev() {
      FlowService.pushPrev(this);
    },
  },
};
</script>
